import { useMemo } from 'react'

import { useIsDark } from '../../../hooks/useIsDark'
import { type ChartColorMode, getChartColorMode } from './chartColorMode'

/** Chart typography and SVG fills that follow Chakra color mode (and Storybook toolbar). */
export const useChartColors = (): ChartColorMode => {
  const isDark = useIsDark()
  return useMemo(() => getChartColorMode(isDark), [isDark])
}
